import { render, staticRenderFns } from "./versiondetails.vue?vue&type=template&id=0c3b353a"
import script from "./versiondetails.vue?vue&type=script&lang=js"
export * from "./versiondetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports